import { render, staticRenderFns } from "./detailQuizz.vue?vue&type=template&id=47b1dce8&"
import script from "./detailQuizz.vue?vue&type=script&lang=js&"
export * from "./detailQuizz.vue?vue&type=script&lang=js&"
import style0 from "./detailQuizz.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports